import React,{useState} from "react"
import { Row, Col } from "react-bootstrap"
import EachSong from "./eachsong"
import { graphql, StaticQuery , Link } from "gatsby"
import "../../Styles/musicsecs.scss"
import {GoTriangleRight} from "react-icons/go"
export default function NewMusics() {
  const [btnhover5 , setbtnhover5] = useState(false)
  return (
    <div>
      <Row>
      <Col md="12" className="music-sec-titles">
        <h1>NEW MUSICS</h1>
        <Link to="./newmusics">
        <span className={btnhover5 ? "badge-hover badge" :"badge" }
        onMouseEnter={() => {
          setbtnhover5(true)
      }}
      onMouseLeave={() => {
        setbtnhover5(false)
      }}
      > 
          <ul>
            <li>
              <small>
                <GoTriangleRight />
              </small>
            </li>
            <li>
            <small>
                Load more
              </small>
            </li>
          </ul>
          <small>

          </small>
        </span></Link>
        <div className="div1">
          <div className="div2"></div>
        </div>
      </Col></Row>
        <div className="scroll-container">
      <StaticQuery
        query={topmusic}
        render={data => {
          return (
           
      <Row>
              {data.allMarkdownRemark.edges.map(({ node }) => (
                  <Col xs={6} sm={4} md={3} lg={2}>
                  <EachSong
                    key={node.id}
                    title={node.frontmatter.title}
                    artist={node.frontmatter.artist}
                    date={node.frontmatter.date}
                    slug={node.fields.slug}
                    fluid={node.frontmatter.image.childImageSharp.fluid}
                  />
               </Col>
              ))}
            </Row>
          )
        }}
      /></div>
    </div>
  )
}

const topmusic = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: [frontmatter___rate], order: DESC }
      limit: 18
      filter: { frontmatter: { cat: { eq: "music" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            rate
            image {
              childImageSharp {
                fluid(maxWidth: 900) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            artist
          }

          fields {
            slug
          }
        }
      }
    }
  }
`
